import React from 'react';
import { Form, Label } from 'semantic-ui-react';
import MediaQuery from 'react-responsive';
import { registerLocale } from 'react-datepicker';
import nz from 'date-fns/locale/en-NZ';
import { format, isValid, toDate } from 'date-fns';

// Global Components
import AsyncDatePicker from 'components/AsyncDatePicker';
import Portal from 'components/Portal';

// Styles
import './styles.scss';

registerLocale('nz', nz);

interface Props {
    input: {
        value: any;
        onBlur: Function;
        onChange: Function;
    };
    label?: string;
    placeholder?: string;
    dateFormat?: string;
    meta: {
        touched?: boolean;
        error?: string;
    };
    selectsEnd?: boolean;
    selectsStart?: boolean;
    startDate?: string;
    endDate?: string;
    disabled?: boolean;
    minDate?: string;
    maxDate?: string;
}

export default class RenderDatePicker extends React.PureComponent<Props> {
    // eslint-disable-next-line react/static-property-placement
    static defaultProps = {
        placeholder: ''
    };

    get date(): Date {
        const { props } = this;

        return new Date(props.input.value);
    }

    get selected(): Date | null {
        const { input } = this.props;

        return input.value && isValid(this.date) ? toDate(this.date) : null;
    }

    handleChange = (date: string): void => {
        if (isValid(date)) {
            this.props.input.onChange(format(new Date(date), 'yyyy-MM-dd'));
        } else {
            this.props.input.onChange(null);
        }
    };

    render(): React.ReactElement {
        const {
            label,
            placeholder,
            dateFormat = 'dd/MM/yyyy',
            meta: { touched, error },
            selectsEnd,
            selectsStart,
            startDate,
            endDate,
            disabled,
            minDate,
            maxDate
        } = this.props;

        let rangeProps: any;

        if (selectsStart) {
            rangeProps = {
                startDate: this.selected,
                endDate: endDate && toDate(new Date(endDate))
            };
        } else if (selectsEnd) {
            rangeProps = {
                startDate: startDate && toDate(new Date(startDate)),
                endDate: this.selected
            };
        }

        return (
            <Form.Field error={!!(touched && error)}>
                {label && <label htmlFor="date-picker">{label}</label>}
                <MediaQuery minWidth={767}>
                    {(matches: boolean): React.ReactElement => (
                        <AsyncDatePicker
                            name="date-picker"
                            popperContainer={Portal}
                            dateFormat={[
                                dateFormat,
                                'EEE do MMM',
                                'dd MMM yyyy',
                                'dd/MM/yyyy',
                                'dd MM yyyy',
                                'dd/MM',
                                'dd-MM'
                            ]}
                            placeholderText={placeholder}
                            selected={this.selected}
                            onChange={this.handleChange}
                            withPortal={!matches}
                            selectsEnd={selectsEnd}
                            selectsStart={selectsStart}
                            {...rangeProps}
                            disabled={disabled}
                            minDate={minDate && toDate(new Date(minDate))}
                            maxDate={maxDate && toDate(new Date(maxDate))}
                            autoComplete="off"
                            locale="nz"
                        />
                    )}
                </MediaQuery>
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}
